import React from 'react';
import { Routes, Route } from 'react-router-dom';
import CompanyLogin from './pages/CompanyLogin';
import EnhancedCompanyDashboard from './pages/EnhancedCompanyDashboard';
import CompanyRegistration from './pages/CompanyRegistration';
import CompanyProfile from './pages/CompanyProfile';
import ReportDetails from './pages/ReportDetails';
import CompanySettings from './pages/CompanySettings';
import InvestigationGuide from './pages/InvestigationGuide';
import InvestigationForm from './pages/InvestigationForm';
import SupportPage from './pages/SupportPage';
import RiskAssessmentList from './pages/RiskAssessmentList';
import InvoiceArchive from './pages/InvoiceArchive';

const CompanyModule = () => {
  return (
    <Routes>
      <Route path="/" element={<CompanyLogin />} />
      <Route path="login" element={<CompanyLogin />} />
      <Route path="register" element={<CompanyRegistration />} />
      <Route path="dashboard" element={<EnhancedCompanyDashboard />} />
      <Route path="profile" element={<CompanyProfile />} />
      <Route path="settings" element={<CompanySettings />} />
      <Route path="support" element={<SupportPage />} />
      <Route path="report/:id" element={<ReportDetails />} />
      <Route path="investigation/guide" element={<InvestigationGuide />} />
      <Route path="investigation-guide" element={<InvestigationGuide />} />
      <Route path="investigation/form/:reportId" element={<InvestigationForm />} />
      <Route path="investigation-form" element={<InvestigationForm />} />
      <Route path="investigation-form/:reportId" element={<InvestigationForm />} />
      <Route path="risk-assessments" element={<RiskAssessmentList />} />
      <Route path="invoices" element={<InvoiceArchive />} />
      <Route path="departments/new" element={<div className="p-8 text-center">Ny avdeling - Under utvikling</div>} />
    </Routes>
  );
};

export default CompanyModule;